import React, { useRef } from "react";
import style from "./../style.module.css";
import Link from "./../../Link";
import formatUrl from "utils/FormatUrl";
import SubMenuCard from "../../SubMenuCard";
import useTranslation from "next-translate/useTranslation";

function index({
  lang,
  t,
  fromMobile,
}: {
  lang: any;
  t: any;
  fromMobile?: boolean;
}) {
  const links = [
    {
      value: t("Vendre rapidement avec agenz"),
      linkTo: "/vendre-rapidement",
      color: "#000",
    },
    {
      value: t("Vendre tout seul"),
      linkTo: "/publier-une-annonce-proprietaire",
      color: "#000",
    },
    {
      value: t("Trouver un agent"),
      linkTo: "/agence-immobiliere-maroc",
      color: "#000",
    },
  ];
  const secondLinks = [
    {
      value: t("Combien coûte ma maison ?"),
      linkTo: "/estimation-immobiliere",
      color: "#000",
    },
    {
      value: t("Créer une visite virtuelle en 3D"),
      linkTo: "/annonce-immobiliere-visite-virtuelle",
      color: "#000",
    },
    {
      value: t("Comment réussir votre vente"),
      linkTo: "/comment-reussir-votre-vente-immobilier-au-maroc",
      color: "#000",
    },
    // {
    //   value: t("Le guide du Vendeur"),
    //   linkTo: "/comment-reussir-votre-vente-immobilier-au-maroc",
    //   color: "#000",
    // },
  ];
  const refCon = useRef(null)

  return (
    <div className={style.container} ref={refCon}>
      <div className={style.innerContainer}>
        <div className={style.firstLinksSection}>
          <p className={style.sectionTitle}>{t("Mes options")}</p>
          {links.map((item, key) => {
            return (
              <Link
                key={key}
                linkTo={formatUrl(item.linkTo, lang)}
                value={t(item.value)}
                isSubNav={false}
                fromSub={true}
                color={item.color}
                arrow={true}
              />
            );
          })}
        </div>
        <div className={style.secondLinksSection}>
          <p className={style.sectionTitle}>{t("Ressources")}</p>
          {secondLinks.map((item, key) => {
            return (
              <div className={style.link}>
                <Link
                  key={key}
                  linkTo={formatUrl(item.linkTo, lang)}
                  value={t(item.value)}
                  isSubNav={false}
                  fromSub={true}
                  color={item.color}
                  arrow={true}
                />
              </div>
            );
          })}
        </div>
        {fromMobile ? null : (
          <div className={style.thirdSection}>
            <SubMenuCard
              title={t("Estimation immobilière")}
              text={t(
                "Moins de deux minutes suffisent pour obtenir l’estimation personnalisée de votre bien"
              )}
              t={t}
              reason={t("Estimez")}
              icon={<></>}
              btn_text={t("Estimez votre bien")}
              vendre={true}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default index;
